export const blurRoot = () => {
  document.getElementById("root")?.setAttribute("style", "filter: blur(5px)");
};

export const unBlurRoot = () => {
  document.getElementById("root")?.setAttribute("style", "");
};

export const disablePopup = (setPopup: any) => {
  setPopup(null);
};

export const formatDate = (date: string) => {
  const re = /(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+).*/;

  return date.replace(re, "$3.$2.$1 $4:$5");
};
